import PropTypes from "prop-types";
import { Button, Empty } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * Empty state for lists that can be filtered: when filters are active it says so and offers a
 * reset right there, instead of a bare "no data" that leaves the user guessing.
 */
function FilteredEmpty({ filters, description }) {
    const { t } = useTranslation("table");

    if (filters?.hasActiveFilters) {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                    <div className="flex flex-col gap-1">
                        <span className="font-medium text-gray-700">{t("noResults")}</span>
                        <span className="text-xs text-gray-500">{t("noResultsHint")}</span>
                    </div>
                }>
                <Button icon={<ReloadOutlined />} onClick={filters.resetFilters}>
                    {t("resetFilters")}
                </Button>
            </Empty>
        );
    }

    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description ?? t("noData")} />;
}

FilteredEmpty.propTypes = {
    filters: PropTypes.shape({
        hasActiveFilters: PropTypes.bool.isRequired,
        resetFilters: PropTypes.func.isRequired,
    }),
    description: PropTypes.node,
};

export default FilteredEmpty;
